import PsyButImg from "./Images/PsyButImg.jpg"
import Link from './Images/Link.jpg'
import MontyPythonHolyGrail from './Images/MontyPythonHolyGrail.png'
import DarthVader from './Images/DarthVader.jpg'
import train from './Images/train.jpg'
import GameofThronesWallpaper from './Images/GameofThronesWallpaper.jpg'
import botimage2 from './Images/botimage2.jpg'
import wordguesser from './Images/wordguesser.jpg'
import OnlineShoppingIcon from './Images/OnlineShoppingIcon.png'
import bestfriends from './Images/bestfriends.jpg'
import hamburger from './Images/hamburger.jpg'
import codespot from './Images/codespot.PNG'
import newspapers from './Images/newspapers.jpg'
import spongebob from './Images/spongebob.jpg'
import photographer from './Images/photographer.jpg'
import newspapersTextImg from './Images/newspapersTextImg.png'
import clickyGameTextImage from './Images/clickyGameTextImage.png'
import sparkitechsTextImage from './Images/sparkitechsTextImage.png'
import codespotTextImage from './Images/codespotTextImage.png'
import friendfinderTextImage from './Images/friendfinderTextImage.png'
import trainschedulerTextImage from './Images/trainschedulerTextImage.png'
import liribotTextImage from './Images/liribotTextImage.png'
import wordguesserTextImage from './Images/wordguesserTextImage.png'
import BamazonTextImage from './Images/BamazonTextImage.png'
import wantaburgerTextImage from './Images/wantaburgerTextImage.png'
import PsychicGameTextImage from './Images/PsychicGameTextImage.png'
import giftasticTextImage from './Images/giftasticTextImage.png'
import crystalcollectorTextImage from './Images/crystalcollectorTextImage.png'
import triviagameTextImage from './Images/triviagameTextImage.png'
import gotquizTextImage from './Images/gotquizTextImage.png'



const ProjectObject = {
    javascriptProj: [
        {
           
            pictureOne: PsyButImg,
            pictureTextOne: PsychicGameTextImage,
            pictureTwo: DarthVader,
            pictureTextTwo: giftasticTextImage,
            paragraphOne: "Psychic Game",
            paragraphTwo: "Giftastic",
            portfolioLinkOne: "https://brandonmgh.github.io/Psychic-Game/",
            portfolioLinkTwo: "https://brandonmgh.github.io/GifTastic/",
            githubOne: "https://github.com/BrandonMGH/Psychic-Game",
            githubTwo: "https://github.com/BrandonMGH/GifTastic"
        },
        {
           
            pictureOne: Link,
            pictureTextOne: crystalcollectorTextImage,
            pictureTwo: train,
            pictureTextTwo: trainschedulerTextImage,
            paragraphOne: "Crystal Clicker Game",
            paragraphTwo: "Train Scheduler",
            portfolioLinkOne: "https://brandonmgh.github.io/unit-4-game/",
            portfolioLinkTwo: "https://brandonmgh.github.io/Firebase-Assignment---Train-Scheduler/",
            githubOne: "https://github.com/BrandonMGH/unit-4-game",
            githubTwo: "https://github.com/BrandonMGH/Firebase-Assignment---Train-Scheduler"
        },
        {
          
            pictureOne: MontyPythonHolyGrail,
            pictureTextOne: triviagameTextImage,
            pictureTwo: GameofThronesWallpaper,
            pictureTextTwo: gotquizTextImage,
            paragraphOne: "Trivia Game",
            paragraphTwo: "Choose your GOT House",
            portfolioLinkOne: "https://brandonmgh.github.io/TriviaGame/",
            portfolioLinkTwo: "https://santo092.github.io/Project-1/",
            githubOne: "https://github.com/BrandonMGH/TriviaGame",
            githubTwo: "https://github.com/santo092/game-of-thrones-quiz"
        },
    ],

    NodeProj: [
        {
          
            pictureOne: botimage2,
            pictureTextOne: liribotTextImage,
            pictureTwo: bestfriends, 
            pictureTextTwo: friendfinderTextImage,
            paragraphOne: "Liri-bot",
            paragraphTwo: "Friend-Finder",
            portfolioLinkOne: "https://github.com/BrandonMGH/liri-node-ap",
            portfolioLinkTwo: "https://friend-finder-app-ucsd.herokuapp.com/home.html",
            githubOne: "https://github.com/BrandonMGH/liri-node-ap",
            githubTwo: "https://github.com/BrandonMGH/Friend-Finder"
        },
        {
          
            pictureOne: wordguesser,
            pictureTextOne: wordguesserTextImage,
            pictureTwo: hamburger,
            pictureTextTwo: wantaburgerTextImage,
            paragraphOne: "Constructor Word Guesser",
            paragraphTwo: "WANT-A-BURGER?!",
            portfolioLinkOne: "https://github.com/BrandonMGH/Constructor-Word-Guess",
            portfolioLinkTwo: "https://want-a-burger.herokuapp.com/",
            githubOne: "https://github.com/BrandonMGH/Constructor-Word-Guess",
            githubTwo: "https://github.com/BrandonMGH/Burger"

        },
        {
           
            pictureOne: OnlineShoppingIcon,
            pictureTextOne: BamazonTextImage,
            pictureTwo: codespot,
            pictureTextTwo: codespotTextImage,
            paragraphOne: "Bamazon SQL Storefront",
            paragraphTwo: "CodeSpot",
            portfolioLinkOne: "https://github.com/BrandonMGH/MySQL_StoreFront_Database-",
            portfolioTwo: "https://codespot.herokuapp.com/",
            githubOne: "https://github.com/BrandonMGH/MySQL_StoreFront_Database-",
            githubTwo: "https://github.com/BrandonMGH/Project2"
        },
    ],

    reactProj: [
        {
            
            pictureOne: newspapers,
            pictureTextOne: newspapersTextImg,
            paragraph: "NewsScraper",
            portfolioLink: "https://quillette-app-scrap.herokuapp.com/",
            github: "https://github.com/BrandonMGH/NewsScraper"
        },
        {
            
            pictureOne: spongebob,
            pictureTextOne: clickyGameTextImage, 
            paragraph: "Clicky-Game",
            portfolioLink: "https://clicky-game-reactjs-app.herokuapp.com/",
            github: "https://github.com/BrandonMGH/Clicky-Game"
        },
        {
         
            pictureOne: photographer,
            pictureTextOne: sparkitechsTextImage, 
            paragraph: "SparkItechs",
            portfolioLink: "https://spark-i-techs.herokuapp.com/",
            github: "https://github.com/avlegend/Project3"
        },

    ],

    TopProj: [
        {
            pictureOne: newspapers,
            pictureTextOne: newspapersTextImg,
            pictureTwo: codespot,
            pictureTextTwo: codespotTextImage,
            paragraphOne: "NewsScraper",
            paragraphTwo: "CodeSpot",
            portfolioLinkOne: "https://quillette-app-scrap.herokuapp.com/",
            portfolioLinkTwo: "https://codespot.herokuapp.com/",
            githubOne: "https://github.com/BrandonMGH/NewsScraper",
            githubTwo: "https://github.com/BrandonMGH/Project2"
        },
        {
            pictureOne: spongebob,
            pictureTextOne: clickyGameTextImage, 
            pictureTwo: bestfriends, 
            pictureTextTwo: friendfinderTextImage,
            paragraphOne: "Clicky-game",
            paragraphTwo: "Friend-Finder",
            portfolioLinkOne: "https://clicky-game-reactjs-app.herokuapp.com/",
            portfolioLinkTwo: "https://friend-finder-app-ucsd.herokuapp.com/home.html",
            githubOne: "https://github.com/BrandonMGH/Clicky-Game",
            githubTwo: "https://github.com/BrandonMGH/Friend-Finder"
        },
        {
            pictureOne: photographer,
            pictureTextOne: sparkitechsTextImage, 
            pictureTwo: train, 
            pictureTextTwo: trainschedulerTextImage,
            paragraphOne: "SparkItechs",
            paragraphTwo: "Train Scheduler",
            portfolioLinkOne: "https://spark-i-techs.herokuapp.com/",
            portfolioLinkTwo: "https://brandonmgh.github.io/Firebase-Assignment---Train-Scheduler/",
            githubOne: "https://github.com/avlegend/Project3",
            githubTwo: "https://github.com/BrandonMGH/Firebase-Assignment---Train-Scheduler"
        },
       
    ]

}

export default ProjectObject